import { combineReducers } from "redux";
import dashboard from "../features/admin/dashboard/slice";

const dashboards = combineReducers({
  dashboard: dashboard,
});

export default dashboards;
